<script>
	import { mapState ,mapActions } from "vuex";
	import FormBeneficios from '@/components/intranet/beneficios/FormBeneficios.vue';
	import ListSolicitudes from '@/components/intranet/beneficios/ListSolicitudes.vue';
	import IconBeneficios from "@/assets/img/icon/section/IconBeneficios.vue";
	export default {
		components: {
			FormBeneficios,
			ListSolicitudes,
			IconBeneficios
		},
		data() {
			return {
				menu: [],
				menu_selected: "",

				filter: {
					show: "1"
				},

				//Loading
				loadingForm: true,
				loadingList: true,

				//DATA
				formulario: [],
				// listSolicitudes: [],
				dataFormuGlobal: {
					id_inventario: null,
					inventario_detalle: null,
					detalle_cantidad: "1",
					valor_formulario: []

				}
			}
		},
		computed: {
			...mapState("BeneficioModule", ["tipoBeneficio", "formularioBeneficio", "listSolicitudes"]), 
		},
		methods: {
			...mapActions("BeneficioModule", ["getTipoBeneficio", "getFormularioBeneficio", "getBeneficiosObtenidosUser"]),

			menuSelected(item) {
				this.menu_selected = item;
				this.menu.forEach(element => {
					element.active = false;
					if(element.id === item.id) element.active = true;
				});
			},

			//GETS
			async getTipoBeneficios(){
				this.loadingList = true;
				let data_ = {
					id_empresa: this.$ls.get("user").id_empresa_fk
				}
				await this.getTipoBeneficio(data_);
				this.loadingList = false;
			},

			async getFormulario(){
				this.loadingForm = true;
				let data_ = {
					id_empresa: this.$ls.get("user").id_empresa_fk,
					id_usuario: this.$ls.get("user").id_usuario,
					id_tipo_solicitud: this.menu_selected.id,
				}
				await this.getFormularioBeneficio(data_);
				this.setFormulario();
				this.loadingForm = false;
			},

			async getSolicitudes() {
				this.loadingList = true;
				let data_ = {
					id_empresa: this.$ls.get("user").id_empresa_fk,
					id_usuario: this.$ls.get("user").id_usuario,
					id_tipo_solicitud: this.menu_selected.id,
				}
				//console.log("acá en getSolicitudes");
				await this.getBeneficiosObtenidosUser(data_);
				// this.listSolicitudes = listSolicitudes;
				this.loadingList = false;

			},

			//SETS
			async setMenu() {
				this.menu = this.tipoBeneficio.map(element => {
					return {
						id: element.id_tipo,
						nombre: element.nombre_solicitud,
						//icono: "fa-solid fa-fire-flame-simple",
						icono: element.url_imagen,
						active: false
					}
				})
				this.menu[0].active = true;
				this.menu_selected = this.menu[0];
				this.setFormulario();
			},
			async setFormulario() {
				this.dataFormuGlobal = {
					id_inventario: null,
					inventario_detalle: null,
					detalle_cantidad: "1",
					valor_formulario: []
				}
				if(this.formularioBeneficio.datos_inventario && this.formularioBeneficio.datos_inventario[0]!=null){
						try{
							this.dataFormuGlobal.id_inventario = this.formularioBeneficio.datos_inventario[0].id_inventario;
						}catch(error){
							console.log("Error setFormulario: ", error);
						}
						
					}
				if(this.formularioBeneficio.datos_formulario) {
					this.formulario = this.formularioBeneficio.datos_formulario.map(element => {
						let inputNoEditable = "";
						let selectOptions = [];
						let errorValue = true;
						let condition = null;
						let id_empresa = this.$ls.get("user").id_empresa_fk
						if(element.tipo_dato === "Default") {
							errorValue = false;
						}
						if(element.tipo_dato === "InputNoEditable") {
							errorValue = false;
						}
						if(element.condicion!=null && element.condicion.includes(';')){
							try{
								let con = element.condicion.split(';');
								con.forEach((item)=>{
									let total = item.split(',');
									if(total[1]== id_empresa){
										condition = total;
									}
								});
							}catch(error){
								console.log("Error setFormulario, condicion!null, error: ", error);
							}
						}
						if(element.datos_selector_empresa.length !== 0) {
							inputNoEditable = element.datos_selector_empresa[0].nombre_detalle;
							element.datos_selector_empresa.forEach(e => {
								selectOptions.push({
									id: e.id_dato_selector,
									label: e.nombre
								});
							});
						}
						else if(element.datos_selector_inventario.length !== 0) {
							inputNoEditable = element.datos_selector_inventario[0].nombre_detalle;
							element.datos_selector_inventario.forEach(e => {
								selectOptions.push({
									id: e.id_detalle,
									label: e.nombre_detalle
								});
							});
						}
						else if(element.datos_selector_producto.length !== 0) {
							inputNoEditable = element.datos_selector_producto[0].nombre_detalle;
							element.datos_selector_producto.forEach(e => {
								selectOptions.push({
									id: e.id_dato_selector,
									label: e.nombre
								});
							});
						}
						return {
							id: element.id_formulario,
							label: element.nombre,
							field: element.tipo_dato,
							value: this.informacionUsurioForm(element.informacion_usuario),
							file_name: "",
							options: selectOptions,
							inputNoEditable: inputNoEditable,
							user_info: element.informacion_usuario,
							error: errorValue,
							condicion: condition
						}
					})
					
				}
				if(!this.formularioBeneficio.datos_formulario) {
					this.formulario = [];
					this.dataFormuGlobal = {
						id_inventario: null,
						inventario_detalle: null,
						detalle_cantidad: "1",
						valor_formulario: []
					}
					console.log("ingrese acá !this.formularioBeneficio.datos_formulario: ", this.dataFormuGlobal);
				}
				// else{
				// 	this.dataFormuGlobal = {
				// 		id_inventario: null,
				// 		inventario_detalle: null,
				// 		detalle_cantidad: "1",
				// 		valor_formulario: []
				// 	}
				// 	console.log("ingrese acá else: ", this.dataFormuGlobal);
				// }
				//console.log("acá en setFormulario: ", this.formulario);
			},
			otraSolicitud() {
				//console.log("otra solicitud?: ");
				this.getFormulario();
			},
			informacionUsurioForm(informacion){
				if(informacion!=null){
					let userInfor = informacion.split(',');
					if(userInfor[0]=="gerencia"){
						//console.log(this.$ls.get("user"));
						return this.$ls.get("user").gerencia[0].bussiness_unit;
					}
				}
				return "";
			}
		},
		watch: {
			menu_selected(){
				//console.log("menu de cosas:");
				this.getFormulario();
				this.getSolicitudes();
			},
			'filter.show'(value){
				//console.log("cambio la variable: ", value);
				if(value=='2'){
					this.getSolicitudes();
				}
				else if(value=="1"){
					this.getFormulario();
				}
			}
		}, 
		async created() {		
			await this.getTipoBeneficios();
			await this.setMenu();
			await this.getFormulario();
			//await this.setFormulario();
			//await this.getSolicitudes();
		},
	}
</script>
<template>
	<section id="beneficios">

		<div class="row">
			<div class="col-12 mb-0">
			<h1 class="h1-custom font-700 mb-1 text-capitalize color-main d-flex align-items-center">
				<IconBeneficios class="me-2 icon-svg-45"/>
				Beneficios
			</h1>

			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
				<li class="breadcrumb-item">
					<router-link 
					to="/home"
					class="color-main"
					>
					<font-awesome-icon icon="fa-solid fa-house"></font-awesome-icon>
					Inicio
					</router-link>
				</li>
				<li class="breadcrumb-item text-capitalize active">
					Beneficios
				</li>
				</ol>
			</nav>
			</div>
		</div>

		<div class="row d-flex mt-2">
			<div class="col-12 col-lg-8 mb-3 mb-lg-0 d-flex align-items-center">
				<p class="text-secondary h5-custom mb-0">
					¡Disfruta los beneficios que tenemos para ti y tu familia! Conócelos y solicítalos aquí.
				</p>
			</div>
			<div class="col-12 col-lg-4 text-end">
				<div 
				class="btn-group btn-group-custom" 
				role="group"
				>
				<input 
					value="1"
					v-model="filter.show"
					type="radio" 
					class="btn-check btn-group-custom-check" 
					name="filtro-noticias" 
					id="radio-recientes" 
					autocomplete="off" 
					checked
				>
				<label 
					class="btn btn-group-custom-label" 
					for="radio-recientes">
					Solicitar
				</label>

				<input 
					value="2"
					v-model="filter.show"
					type="radio" 
					class="btn-check btn-group-custom-check" 
					name="filtro-noticias" 
					id="radio-mas-vistos" 
					autocomplete="off"
				>
				<label 
					class="btn btn-group-custom-label" 
					for="radio-mas-vistos"
					>
					Historial
				</label>
				</div>     
			</div>
			</div>


		<div class="row">
			<div class="col-12">
			<div class="border-bottom mb-3 pb-3"></div>
			</div>
		</div>

		<div class="row">
			<div class="col-12 col-lg-5">
				<div class="list-group list-group-custom">
					<a 	
						v-for="item in menu" :key="item.id"
						@click="menuSelected(item)"
						href="javascript:" 
						class="list-group-item list-group-item-action"
						:class="item.active ? 'active': '' "
					>
						<div class="d-flex align-items-center">
							<div class="flex-shrink-0 fs-3 list-group-custom-icon text-center w-50-custom">
								<!-- <font-awesome-icon :class="item.icono"></font-awesome-icon> -->
								<img class="h-50-custom" :src="item.icono">
							</div>
							<div class="flex-grow-1 ms-3 list-group-custom-text">
								{{ item.nombre }}
							</div>
						</div>
					</a>
				</div>
			</div>
			<div class="col-12 col-lg-7 mt-3 mt-lg-0">
				<div
					v-if="filter.show === '1' " 
					class="card card-shadow border-0">
					<div class="card-body">
						<h4 class="font-700 color-main d-flex justify-content-between border-bottom pb-2 mb-3">
							<span>
								<font-awesome-icon icon="fa-solid fa-circle-plus"></font-awesome-icon>
								Ingreso de solicitud
							</span>
							<span class="badge border border-main color-main">
								<span :key="menu_selected.icono">
									<font-awesome-icon :icon="menu_selected.icono"></font-awesome-icon>

								</span>
								{{ menu_selected.nombre }}
							</span>
						</h4>

						<FormBeneficios
							v-if="formulario"
							:data="formulario"
							:tipo="menu_selected.id"
							:dataGlobal="dataFormuGlobal"
							:loading="loadingForm"
							@agregarOtraSolicitud="otraSolicitud"
						/>
					</div>
				</div>
				<div 
					v-if="filter.show === '2' " 
					class="card card-shadow border-0"
				>
					<div class="card-body">
						<h4 class="font-700 color-main d-flex justify-content-between border-bottom pb-2 mb-3">
							<span>
								<font-awesome-icon icon="fa-solid fa-list-check"></font-awesome-icon>
								Historial de solicitudes
							</span>
							<span class="badge border border-main color-main">
								<span :key="menu_selected.icono">
									<font-awesome-icon :icon="menu_selected.icono"></font-awesome-icon>
								</span>
								{{ menu_selected.nombre }}
							</span>
						</h4>
						<ListSolicitudes 
							:data="listSolicitudes"
							:loading="loadingList" 
						/>
					</div>
				</div>
			</div>
		</div>

	</section>
</template>
<style lang="scss">
	
</style>